import React, { useMemo } from 'react'

const rateList = Array(5).fill(0)

function Rating({...props}) {

  const handleMouseOver = (rate) => {
    props?.onChange(rate)
  }

  const ratelist = useMemo(() => {
    let tmp = [...rateList]
    return tmp.fill(1, 0, props.value)
  },[props.value])

  return (
    <div className='flex gap-1'>
      {
        props.style === 'primary' ?
        ratelist.map((cnt, index) => (
          <div 
            key={index} 
            className={`w-[18px] h-[18px] cursor-pointer rounded-[4px] border-[3px] ${cnt === 1 ? 'bg-primary' : 'bg-white'}`}
            onClick={() => props.disabled ? {} : handleMouseOver(index+1)}
          />
        ))
        :
        props.style === 'light' ?
        ratelist.map((cnt, index) => (
          <div 
            key={index} 
            className={`w-[18px] h-[18px] cursor-pointer rounded-[4px] border-[3px] ${cnt === 1 ? 'bg-white' : 'bg-primary'}`}
            onClick={() => props.disabled ? {} : handleMouseOver(index+1)}
          />
        )) 
        : null
      }
    </div>
  )
}

export default Rating